export enum NotificationType {
  VIDEO_ISSUE = 'VIDEO_ISSUE',
  SYSTEM = 'SYSTEM',
  MENTION = 'MENTION',
  USER_ACTIVATED_BY_GATEKEEPER = 'USER_ACTIVATED_BY_GATEKEEPER',
  USER_CREATED_BY_GATEKEEPER = 'USER_CREATED_BY_GATEKEEPER',
  USER_SELF_SIGNUP = 'USER_SELF_SIGNUP',
  COMMENT_REPORTED = 'COMMENT_REPORTED',
  COMMENT_REPORT_RESOLVED = 'COMMENT_REPORT_RESOLVED',
}

export enum NotificationStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export interface NotificationMetadata {
  videoUrl?: string;
  videoTitle?: string;
  battleId?: string;
  battleUuid?: string;
  battleName?: string;
  userDescription?: string;
  commentUuid?: string;
  commentId?: number;
  commentAuthorUserId?: number;
  commentAuthorUsername?: string;
  reportedText?: string;
  reportReason?: string;
  resolved?: boolean;
  resolutionAction?: 'dismissed' | 'removed';
  resolvedByUserId?: number;
  resolvedByUsername?: string;
  gatekeeperId?: number;
  gatekeeperUsername?: string;
  targetUserId?: number;
  targetUsername?: string;
  targetEmail?: string;
}

export interface ReportedByUser {
  id: number;
  username: string;
  email: string;
}

export interface Notification {
  id: number;
  type: NotificationType;
  status: NotificationStatus;
  title: string;
  message: string;
  metadata?: NotificationMetadata;
  reportedByUserId?: number;
  reportedBy?: ReportedByUser;
  createdAt: string;
  readAt?: string;
}

export interface ReportVideoIssueDto {
  battleUuid: string;
  videoUrl: string;
  videoTitle: string;
  userDescription?: string;
}
